import { Typography } from "@mui/material";

export const CardCaption = ({ children, textColor }) => (
    <Typography variant="caption" color={textColor}>
        {children}
    </Typography>
);
